export default {"src":"/_next/static/media/ic-profile.38adae13.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};